import _ from '../../common/utility';
import objectFitImages from 'object-fit-images';
import ad from './ad';

function load (cb) {
    if (!_.isCOE()) return;

    if ($('.colab-logo').length === 0 ) {
        $('.coe .header-logo').remove();
    }

    let title = conceptName.toLowerCase();
    let sourceMarker = 'dpcs';
    let url = '';
    const lang = window.locale;
    if(lang === 'es' || lang === 'pt') url = `https://img.${getDomain()}medscapestatic.com/medscape-files/coe/${lang}/${title}.json`;
    else url = `https://img.${getDomain()}medscapestatic.com/medscape-files/coe/${title}.json`;

    $.ajaxSetup({
        timeout: 0
    });

    $.get(url)
        .done(function (resp) {
            let featured, icymi;

            if (resp.metadata) {
                title = resp.metadata.tracking || title;
                sourceMarker = resp.metadata.sourceMarker || sourceMarker;
            }

            featured = '<section class="coe_featured"><ul>';
            for (let i = 0; i < resp.Featured.length; i++) {
                let content = resp.Featured[i];
                let video = content.video ? '<span class="imgVideo"></span>' : '';
                let logo = content.logo ? `<img class="colab-logo-inline" src="${content.logo}">` : '';
                if (i === 0 ) {
                    featured += `
                    <li>
                        <a href="${content.link}?src=${sourceMarker}" onclick="wmdTrack('coe-fc_1')">
                            <img src="//img.qa02.medscapestatic.com/pi/global/1x1.png" data-src="${content.thumb}" data-alt="${content.alt}">
                            ${video}
                        </a>
                        <div>
                            <div class="tag callouttag"><span class="tag-text">${content.pub}</span>${logo}</div>
                            <a href="${content.link}?src=${sourceMarker}" onclick="wmdTrack('coe-fc_1')">
                                <div class="title">${content.title}</div>
                            </a>
                            <div class="teaser">${content.teaser}</div>
                        </div>
                    </li>`;
                } else {
                    featured += `
                    <li>
                        <div class="tag callouttag"><span class="tag-text">${content.pub}</span>${logo}</div>
                        <a href="${content.link}?src=${sourceMarker}" onclick="wmdTrack('coe-fc_${i + 1}')">
                            <img src="//img.medscapestatic.com/pi/global/1x1.png" data-src="${content.thumb}" data-alt="${content.alt}">
                            ${video}
                        </a>
                        <a href="${content.link}?src=${sourceMarker}" onclick="wmdTrack('coe-fc_${i + 1}')">
                            <div class="title">${content.title}</div>
                        </a>
                    </li>`;
                }
                if (i === 2) {
                   if (_.getBreakpoint() === 1) {
                       featured += `
                           <li class="ad-item"><div id="ads-pos-1520-sfp" class="AdUnit AdUnit-sfp"></div></li>
                           `
                   } else {
                       featured += `
                           <li class="ad-item"><div id="ads-pos-520-sfp" class="AdUnit AdUnit-sfp"></div></li>
                           `
                   }
                }
            }
            featured += '</ul></section>';
			if ($('#ads-pos-1523').length > 0) {
				$('#ads-pos-1523').after(featured);
			} else {			
				$('.coe header').after(featured);
			}
            let inCaseYouMissed;
            if (window.locale == 'es') {
                inCaseYouMissed = "Más contenido"
            }
            else if (window.locale == 'pt') {
                inCaseYouMissed = "Mais conteúdos"
            }
            else {
                inCaseYouMissed = "In Case You Missed It"
            }
            icymi = `<section class="coe_icymi"><div class="header">${inCaseYouMissed}</div><ul>`;
            for (let i = 0; i < resp.ICYMI.length; i++) {
                let content = resp.ICYMI[i];
                let video = content.video ? '<span class="imgVideo"></span>' : '';
                let logo = content.logo ? `<img class="colab-logo-inline" src="${content.logo}">` : '';
                icymi += `
                <li>
                    <a href="${content.link}?src=${sourceMarker}" onclick="wmdTrack('coe-icymi_${i + 1}')">
                        <img src="//img.medscapestatic.com/pi/global/1x1.png" data-src="${content.thumb}" data-alt="${content.alt}">
                        ${video}
                    </a>
                    <div>
                        <div class="tag callouttag"><span class="tag-text">${content.pub}</span>${logo}</div>
                        <a href="${content.link}?src=${sourceMarker}" onclick="wmdTrack('coe-icymi_${i + 1}')">
                            <div class="title">${content.title}</div>
                        </a>
                    </div>
                </li>`;
            }
            icymi += '</ul></section>';
            $('main.coe').after(icymi);

            cb();

            objectFitImages('img');
            if (_.getBreakpoint() === 1) {
				if ($('#ads-pos-1420-sfp').length > 0) {
					delete window.ads2_ignore["1420"];
					webmd.ads2.defineAd({id:'ads-pos-1420-sfp', pos:1420, sizes:[2,4]});
				}
				if ($('#ads-pos-1712-sfp').length > 0) {
					delete window.ads2_ignore["1712"];
					webmd.ads2.defineAd({id:'ads-pos-1712-sfp', pos:1712, sizes:[2,4]});
				}
				if ($('#ads-pos-1520-sfp').length > 0) {
					delete window.ads2_ignore["1520"];
					webmd.ads2.defineAd({id:'ads-pos-1520-sfp', pos:1520, sizes:[2,4]});
				}
                // webmd.ads2.refresh({pos:{1420:true,1712:true,1520:true}});
            } else {
				if ($('#ads-pos-420-sfp').length > 0) {
					delete window.ads2_ignore["420"];
					webmd.ads2.defineAd({id:'ads-pos-420-sfp', pos:420, sizes:[2,4]});
				}
				if ($('#ads-pos-520-sfp').length > 0) {
					delete window.ads2_ignore["520"];
					webmd.ads2.defineAd({id:'ads-pos-520-sfp', pos:520, sizes:[2,4]});
				}
				if ($('#ads-pos-141-sfp').length > 0) {
					delete window.ads2_ignore["141"];
					webmd.ads2.defineAd({id:'ads-pos-141-sfp', pos:141, sizes:[[2,4], [300,250]]});
				}
                //  webmd.ads2.refresh({pos:{141:true,420:true,520:true}});
            }

            $(document).one('dfpRenderComp', function () {
                if (breakpoint === 1) {
                    var coeFallback = $('#ads-pos-1712-sfp');
                }
                else {
                    var coeFallback = $('#ads-pos-141-sfp');
                }
                setTimeout(function () {
                    if ($(coeFallback).length > 0) {
                        if (!$(coeFallback).closest('section').hasClass('has-ad') && !$(coeFallback).hasClass('blank-ad')) {
                            $(coeFallback).closest('section').addClass("has-ad has-ad-label");
                        }
                    }
                }, 1000);
            });
        });
}

export default _.catch(load);